import Team from "../../../../src/components/Team";
import * as React from 'react';
export default {
  Team,
  React
};